import React, { useState } from 'react';
import {
    Box, Flex, Text, Heading, Badge, Image, HStack, Button, IconButton, Icon,
} from '@chakra-ui/react';
import { FiSmartphone, FiX } from 'react-icons/fi';
import MarkdownContent from './MarkdownContent';

/**
 * 老師端「家長端手機預覽」浮動抽屜。
 * 以目前編輯中的內容即時模擬家長端公告詳情頁 (/parent/announcements/:id)。
 * 固定於右下角，可開合；僅桌面顯示。
 */
const PhonePreview = ({
    title, summary, content, category,
    coverUrl, coverPosition = '50% 50%', isEmergency = false,
}) => {
    const [open, setOpen] = useState(false);

    return (
        <Box
            position="fixed" bottom="20px" right="20px" zIndex={1500}
            display={{ base: 'none', md: 'flex' }} flexDirection="column" alignItems="flex-end"
        >
            {open && (
                <Box
                    w="330px" maxH="78vh"
                    bg="white" borderRadius="md" overflow="hidden"
                    border="1px solid" borderColor="gray.200" boxShadow="lg"
                    mb={3} display="flex" flexDirection="column"
                >
                    {/* 頂部列（簡潔淺色） */}
                    <Flex align="center" justify="space-between" px={3} py={2} bg="gray.50" color="gray.600" borderBottom="1px solid" borderColor="gray.200" flexShrink={0}>
                        <Text fontSize="xs" fontWeight="bold">家長端預覽 · 校園公告</Text>
                        <IconButton
                            aria-label="關閉預覽" size="xs" variant="ghost" color="gray.500"
                            icon={<FiX />} onClick={() => setOpen(false)} _hover={{ bg: 'gray.200' }}
                        />
                    </Flex>

                    {/* 內容：模擬 /parent/announcements/:id 詳情頁 */}
                    <Box overflowY="auto" bg="gray.50">
                        {coverUrl && (
                            <Image src={coverUrl} w="100%" maxH="170px" objectFit="cover" objectPosition={coverPosition} alt="" />
                        )}
                        <Box px={4} pt={4} pb={6}>
                            <HStack spacing={2} mb={2}>
                                {isEmergency && <Badge colorScheme="red" borderRadius="full" px={2}>緊急</Badge>}
                                {category && <Badge colorScheme="blue" borderRadius="full" px={2}>{category}</Badge>}
                            </HStack>
                            <Heading size="md" color="gray.800" mb={1}>{title || '（公告標題）'}</Heading>
                            <Text fontSize="xs" color="gray.400" mb={3}>發布後顯示實際時間</Text>
                            {summary && <Text color="gray.600" fontWeight="medium" mb={3}>{summary}</Text>}
                            {content ? (
                                <MarkdownContent content={content} />
                            ) : (
                                <Text color="gray.700" whiteSpace="pre-wrap" lineHeight="1.8">（內容）</Text>
                            )}
                        </Box>
                    </Box>
                </Box>
            )}

            <Button
                leftIcon={<Icon as={FiSmartphone} />}
                colorScheme="blue" borderRadius="full" boxShadow="lg"
                onClick={() => setOpen((o) => !o)}
            >
                {open ? '收起預覽' : '預覽家長端'}
            </Button>
        </Box>
    );
};

export default PhonePreview;
